export default "__VITE_ASSET__BCQers_D__"